import { CATEGORIES } from '@/utils/categoryConstants';

/**
 * Tailwind utility classes per LOCI category id.
 * Mirrors the previous local `Badge` wrapper's `categoryVariants` cva map so
 * existing visual tinting is preserved after the wrapper deletion.
 */
export const CATEGORY_BADGE_CLASSES: Record<string, string> = {
  music: 'bg-purple-100 text-purple-800 hover:bg-purple-200 border-purple-200',
  sports: 'bg-orange-100 text-orange-800 hover:bg-orange-200 border-orange-200',
  food: 'bg-green-100 text-green-800 hover:bg-green-200 border-green-200',
  tech: 'bg-blue-100 text-blue-800 hover:bg-blue-200 border-blue-200',
  art: 'bg-pink-100 text-pink-800 hover:bg-pink-200 border-pink-200',
  drinks: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200 border-yellow-200',
};

export function categoryBadgeClass(cat: string): string {
  const normalized = cat.toLowerCase();
  if (!CATEGORIES.some((c) => c.id === normalized)) return '';
  return CATEGORY_BADGE_CLASSES[normalized] ?? '';
}
